/**
 * 语言拦截器
 *
 * 自动在 HTTP 请求中添加 Accept-Language header
 */

import { psAxios } from '@patsnap/common-ps-http';
import type { AxiosRequestConfig } from 'axios';

/**
 * 前端语言代码 -> 后端语言代码映射
 */
const LANG_MAP: Record<string, string> = {
    'cn': 'zh-hans',
    'en': 'en',
    'tw': 'zh-hant',
    'jp': 'ja',
};

/**
 * 初始化语言拦截器
 *
 * 从 i18n 实例获取当前语言，并添加到所有请求的 Accept-Language header
 */
export const initLanguageInterceptor = () => {
    psAxios.interceptors.request.use(
        (config: AxiosRequestConfig) => {
            try {
                // 从 document.cookie 获取语言设置
                const pattern = /---uniform-setting-locale=(\w+)/;
                const [, lang] = document.cookie.match(pattern) || [];

                if (lang) {
                    // 映射前端语言代码到后端
                    const backendLang = LANG_MAP[lang] || 'zh-hans';

                    // 添加 Accept-Language header
                    if (!config.headers) {
                        config.headers = {};
                    }

                    if (!config.headers['Accept-Language']) {
                        config.headers['Accept-Language'] = backendLang;
                    }
                }
            } catch (error) {
                console.error('[Language Interceptor] Failed to add language header:', error);
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};
